import { initModal } from 'assets/core/js/module/paymentFacilities'
import dataLayer from 'assets/core/js/page/search/dataLayer'
import productFavorite from 'assets/core/js/page/search/product/favorite'
import faqToggle from 'assets/themes/vacances-campings/js/module/faqToggle'
import searchForm from 'assets/themes/vacances-campings/js/module/searchForm'
import budgetSlider from 'assets/themes/vacances-campings/js/page/search/budgetSlider'
import filters from 'assets/themes/vacances-campings/js/page/search/filters'
import imagesSliders from 'assets/themes/vacances-campings/js/page/search/imagesSliders'
import loading from 'assets/themes/vacances-campings/js/page/search/loading'
import map from 'assets/themes/vacances-campings/js/page/search/map'
import openProductPageLinks from 'assets/themes/vacances-campings/js/page/search/openProductPageLinks'
import recap from 'assets/themes/vacances-campings/js/page/search/recap'
import reminder from 'assets/themes/vacances-campings/js/page/search/reminder'
import sorting from 'assets/themes/vacances-campings/js/page/search/sorting'
import fixedDates from 'assets/themes/vacances-campings/js/page/thematic/fixed-dates'

document.addEventListener('DOMContentLoaded', function () {
  faqToggle()
  dataLayer()
  imagesSliders.init()
  budgetSlider()
  openProductPageLinks()
  initModal()
  sorting()
  loading()
  filters()
  recap()
  reminder()
  map.init()
  productFavorite()

  searchForm()

  if (document.querySelector('[data-theme=fixed-dates]') !== null) {
    fixedDates.init()
  }
})
